define('controllers/fieldTerms',[], function() {
    var controller = Marionette.Object.extend( {
        initialize: function() {
            this.listenTo( nfRadio.channel( 'terms' ), 'init:model', this.register );
        },

        register: function( model ) {
            // nfRadio.channel( 'field-' + this.model.get( 'id' ) ).trigger( 'click:extra', e, this.model );
            this.listenTo( nfRadio.channel( 'field-' + model.get( 'id' ) ), 'click:extra', this.clickExtra );
            this.listenTo( nfRadio.channel( 'field-' + model.get( 'id' ) ), 'keyup:field', this.keyUpExtra );
        },
        
        clickExtra: function( e, model ) {
            var el = jQuery( e.currentTarget );
            var input = el.parent().find( '.extra-value' );

            this.addOption( model, input.val() );
            input.val( '' );
        },

        keyUpExtra: function( el, model, keyCode ) {
            if( 13 != keyCode ) return;

            this.addOption( model, el.val() );
            el.val( '' );
        },

        addOption: function( model, value ) {
            value = ( value || '' ).replace( /^\s+|\s+$/g, '' );
            if( ! value ) return;
            var options = model.get( 'options' );
            var existingOption = _.find( options, function( option ) {
                return String( option.label ).toLowerCase() == value.toLowerCase();
            } );

            if( existingOption ) {
                value = existingOption.value;
            } else {
                options.push( {
                    label: value,
                    value: value,
                    selected: 0,
                } );
            }

            var selected = model.get( 'value' ) || [];
            if( 'string' == typeof selected ) selected = selected ? [ selected ] : [];
            if( -1 == selected.indexOf( value ) ) selected.push( value );

            model.set( 'value', selected );
            model.trigger( 'reRender' );

            this.focusAddNew( model );
        },

        /*
         * Put the cursor back in the add-new box after the field re-renders.
         *
         * Re-rendering replaces the whole term list, which drops focus to the top
         * of the page. A visitor adding a second term - and anyone working without
         * a mouse - would otherwise have to find their way back. See #8131.
         */
        focusAddNew: function( model ) {
            var inputId = 'nf-field-' + model.get( 'id' ) + '-new-term';

            setTimeout( function() {
                var input = document.getElementById( inputId );
                if( input ) input.focus();
            }, 0 );
        }
        
    });

    return controller;
} );

